import { ReactText } from 'react';

export const formatOptions = <Value extends ReactText>(options: Value[]) =>
  options.map((option) => ({ label: `${option}`, value: option }));
